<template>
  <!-- <div class="bloom-diaolg"> -->
    <el-dialog
      :visible.sync="visible"
      :show="show"
      :show-close="false"
      :close-on-click-modal="closeOnClickModal"
      append-to-body
      @close="OnClose()"
      class="bloomDialog"
      :width="width + 'px'"
      :top="top">
      <div class="icon-room" v-if="hasCloseIcon" @click="$emit('update:show', false)"><i class="blpc icon-size">&#xe6ce;</i></div>
      <slot></slot>
    </el-dialog>
  <!-- </div> -->
</template>

<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: 1000
    },
    hasCloseIcon: { type: Boolean, default: true },
    top: {
      type: [String, Number],
      default: '100px'
    },
    show: { type: Boolean, default: false },
    closeOnClickModal: { type: Boolean, default: true }
  },
  data () {
    return {
      visible: this.show
    }
  },
  watch: {
    show: {
      immediate: true,
      handler (show) {
        this.visible = this.show
      }
    }
  },
  methods: {
    OnClose () {
      this.$emit('update:show', false)
      // this.$emit('close', false)
    }
  }
}
</script>

<style lang="scss">
.bloomDialog {
  .el-dialog{
    border-radius: 16px;
    // background: red;
    padding: 40px;
    position: relative;
    .icon-room {
      position: absolute;
      top: -35px;
      right: 0px;
      .icon-size {
        color: #fff;
        cursor: pointer;
      }
    }
    .room-body {
      .title {
        font-size: 20px;
        color: #030A17;
      }
      .name {
        margin-bottom: 8px;
        font-weight: 600;
      }
      .blue {
        display: inline-block;
        color: #296bff;
      }
      .info-item {
        .input-item {
          height: 40px;
          width: 372px;
          position: relative;
          &::before {
            content: '';
            position: absolute;
            height: 16px;
            width: 1px;
            opacity: 0.22;
            background: #787A95;
            left: 40px;
            top: 12px;
            z-index: 2;
          }
          input {
            background: #F0F0F7;
            border: none;
            text-indent: 1.5em;
          }
          .font-pc {
            color: #000;
            padding: 8px;
          }
        }
      }
      .el-input__prefix, .el-input__suffix {
        color: #000;
      }
      .mb16 {
        margin-bottom: 16px;
      }
      .mb24 {
        margin-bottom: 24px;
      }
    }
      margin-top: 48px;
    .mt48 {
      margin-top: 48px;
    }
    .btn-group-room {
      display: flex;
      justify-content: space-between;
      .btn {
        height: 40px;
        width: 178px;
        cursor: pointer;
        border-radius: 4px;
        text-align: center;
        line-height: 40px;
        font-weight: 600;
        font-size: 16px;

        box-sizing: border-box;
        &.default {
          color: #DE2A0B;
          border: 2px solid #DE2A0B;
          line-height: 36px;
        }
        &.danger {
          color: #fff;
          background-image: linear-gradient(180deg, #F0531A 0%, #DD290B 100%);
        }
      }
    }
  }
  .el-dialog__header{
    padding: 0;
  }
  .el-dialog__body{
    padding: 0;
    color: #212121;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/bloom-dialog.vue